import * as React from "react";

import { Link } from "react-router-dom";
import LayoutGrid from "@tunnel-components/layouts/layout/index";
import BreadCrumb from "@tunnel-components/@sharded/widgets/breadcrumb/component";
import CheckBoxGrid from "@tunnel-components/@sharded/@widgets/checkbox/component";
// import * as noCache from "shortid";
import Masque from "@tunnel-components/@sharded/masque";
import * as Enums from "@tunnel-enums/index";
import * as Utils from "@Cyclope-Utils/index";
import * as Paths from "@tunnel-enums/index";
import * as Lodash from "lodash";
import cx from "classnames";
import * as shortid from "shortid";
import Stream from "@tunnel-components/@sharded/widgets/stream-live/component";
import * as i18next from "i18next";
import Scrollbars from "@tunnel-components/@sharded/@widgets/scrollbars";
import MessageEmptyIncidents from "@tunnel-components/@sharded/message/component";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { any } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (props: any): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  // desturation
  const {
    loading,
    fluxLive,
    onSubmit,
    onFluxLive,
    succeesNext,
    remouvecamera,
    onEditeCamera,
    onCloseCamera,
    editioncamerasuccees,
    editioncameraerror,
    editionErrorIsDuplication,
    disabledcamera,
    onRemouveCamera,
    getCameraDetails,
    suppressioncamerasuccees,
    suppressioncameraerror,
    filterIncidentTypes,
    checkTypesIncidents,
    onChange,
  } = props;

  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();

  /**
   * @description : retourne un boolean
   * @const
   * @name authorizationSegmentation
   * @type { boolean  }
   */
  const authorizationSegmentation: boolean = Utils.simpleAuthorizationIsAllowed(
    User,
    [Enums.AuthorizationRightsEnums.CAMERASEGMENTATIONVIEW]
  );

  /**
   * @description : retourne un boolean ( )
   * @const
   * @name siteLoading
   * @type { boolean  }
   */
  const siteLoading: boolean =
    !Lodash.isEmpty(getCameraDetails) &&
    !Lodash.isUndefined(getCameraDetails) &&
    !Lodash.isNull(getCameraDetails);

  /**
   * @description : retourne un boolean
   * @const
   * @name authorization
   * @type { boolean  }
   */
  const authorization: boolean =
    siteLoading &&
    Utils.simpleAuthorizationIsAllowed(User, [
      Enums.AuthorizationRightsEnums.CAMERAEDITEDHIBITION,
    ]) &&
    !getCameraDetails.isStoppedBySae;

  const noAction = (e: any) => e.preventDefault();

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <LayoutGrid
      snackbar={succeesNext}
      editioncamerasuccees={editioncamerasuccees}
      editioncameraerror={editioncameraerror}
      editionErrorIsDuplication={editionErrorIsDuplication}
      disabledcamera={disabledcamera}
      suppressioncamerasuccees={suppressioncamerasuccees}
      suppressioncameraerror={suppressioncameraerror}
      remouvecamera={remouvecamera}
      onCloseCamera={onCloseCamera}
      onEditeCamera={onEditeCamera}
      onRemouveCamera={onRemouveCamera}
      someTextSuccees={i18next.t("les parametres ont ete modifies")}
      cameraInformation={...props}
      cameraSetting={props.cameraSetting}
      loading={loading}
      authorization={authorization}
      error={props.errorserver}
    >
      {!siteLoading && (
        <MessageEmptyIncidents message={i18next.t("cette camera supprimer")} />
      )}
      {siteLoading && (
        <section className="tunnel-site animated fadeIn">
          <BreadCrumb
            iconSupervision={true}
            links1={Paths.PathsNamesEnums.CAMERAHOME}
            title={i18next.t("supervision")}
            breadText1={i18next.t("cameras")}
            breadText2={` # ${getCameraDetails && getCameraDetails.code}`}
            paramLinks={
              Paths.PathsNamesEnums.ONECAMERASEGMENTATIONSEQUENCE +
              `${
                getCameraDetails &&
                getCameraDetails.section &&
                getCameraDetails.section.id
              }/${getCameraDetails && getCameraDetails.id}`
            }
          />

          <div className="contentAllSiteWithoutOnglet ">
            <section className="columnsWithoutOnglet">
              <section className="content-wrapper">
                <section className="incident-items  settingsCamera">
                  <div className="incident-player">
                    <span className={cx("", { borderGradian: fluxLive[0] })}>
                      <span
                        className={cx("spanBGWithe", {
                          "hls-active ": fluxLive[0],
                        })}
                        onClick={onFluxLive(0)}
                      >
                        {" "}
                        <span className={cx("", { textGradian: fluxLive[0] })}>
                          {i18next.t("masque")}
                        </span>
                      </span>
                    </span>
                    <span
                      className={cx("", { borderGradian: fluxLive[1] })}
                      style={{ marginLeft: "5px" }}
                    >
                      {Utils.simpleAuthorizationIsAllowed(User, [
                        Enums.AuthorizationRightsEnums.CAMERAFLUXLIVE,
                      ]) && (
                        <span
                          className={cx("spanBGWithe", {
                            "hls-active": fluxLive[1],
                          })}
                          onClick={onFluxLive(1)}
                        >
                          <span
                            className={cx("", { textGradian: fluxLive[1] })}
                          >
                            {i18next.t("en direct")}
                          </span>
                        </span>
                      )}
                    </span>
                  </div>

                  <div className="one-incident-details with-1-3-columns">
                    <li className="cart-box-incidents">
                      <div className="cart-incident">
                        <div className="cartImageNoImage">
                          {fluxLive[0] && !fluxLive[1] && (
                            <div className="image-with-snapshot camera-masque-warning animated fadeIn">
                              {getCameraDetails.connected && (
                                <div
                                  className="cameravision"
                                  style={{
                                    top: `${
                                      getCameraDetails.proposedDistancePixels *
                                      100
                                    }%`,
                                  }}
                                />
                              )}
                              {props.connected &&
                                !props.move &&
                                !props.noSignal && (
                                  <Masque
                                    target={props.snapshotCamera}
                                    camera={props.cameraIdentifiant}
                                    virtualDomUpdate={props.virtualDomUpdate}
                                  />
                                )}
                              {!props.connected && (
                                <div className="impossible" />
                              )}

                              {props.connected &&
                                props.snapshotCamera === "" && (
                                  <div className="impossible" />
                                )}
                              {props.connected &&
                                props.move &&
                                !props.noSignal && (
                                  <div className="came-lg">
                                    <div className="BougeCamera" />
                                    <Masque
                                      target={props.snapshotCamera}
                                      camera={props.cameraIdentifiant}
                                      virtualDomUpdate={props.virtualDomUpdate}
                                    />
                                  </div>
                                )}

                              {props.connected && props.noSignal && (
                                <div className="came-lg">
                                  <div className="NoSignalCamera" />
                                  <Masque
                                    target={props.snapshotCamera}
                                    camera={props.cameraIdentifiant}
                                    virtualDomUpdate={props.virtualDomUpdate}
                                  />
                                </div>
                              )}
                              <div className="noSignalMove">
                                {!props.connected &&
                                  !getCameraDetails.isStoppedBySae && (
                                    <p style={{ display: "block" }}>
                                      {" "}
                                      {i18next.t("pas de flux video")}
                                    </p>
                                  )}
                                {!props.connected &&
                                  getCameraDetails.isStoppedBySae && (
                                    <p style={{ display: "block" }}>
                                      {" "}
                                      {i18next.t("pas de flux video")} -{" "}
                                      {i18next.t("camera stoppee sae")}
                                    </p>
                                  )}
                                {props.connected &&
                                  props.snapshotCamera === "" && (
                                    <p style={{ display: "block" }}>
                                      {" "}
                                      {i18next.t(
                                        "impossible de charger l'image"
                                      )}
                                    </p>
                                  )}
                                {props.connected && props.noSignal && (
                                  <p style={{ display: "block" }}>
                                    {i18next.t(
                                      "pas de signal video sur encodeur"
                                    )}
                                  </p>
                                )}
                                {props.connected &&
                                  props.move &&
                                  !props.noSignal && (
                                    <p style={{ display: "block" }}>
                                      {i18next.t("bouge de camera")}
                                    </p>
                                  )}
                              </div>
                            </div>
                          )}
                          {fluxLive[1] && !fluxLive[0] && (
                            <div className="image-with-snapshot camera-masque-warning">
                              {!props.connected && (
                                <div className="impossible" />
                              )}
                              {props.connected &&
                                props.liveIncidentUrl &&
                                props.liveIncidentUrl !== "" && (
                                  <Stream
                                    localUrl={props.liveIncidentUrl}
                                    name={props.nameCamera}
                                  />
                                )}
                              {!props.connected && (
                                <div className="noSignalMove">
                                  <p style={{ display: "block" }}>
                                    {" "}
                                    {i18next.t("pas de flux video")}
                                  </p>
                                </div>
                              )}
                            </div>
                          )}
                        </div>

                        <div className="btnSettingsCamera">
                          <span>
                            {authorizationSegmentation && (
                              <Link
                                to={{
                                  pathname:
                                    Paths.PathsNamesEnums
                                      .ONECAMERASEGMENTATIONSEQUENCE +
                                    `${
                                      getCameraDetails &&
                                      getCameraDetails.section &&
                                      getCameraDetails.section.id
                                    }/${
                                      getCameraDetails && getCameraDetails.id
                                    }`,
                                }}
                              >
                                <span className="borderGradian">
                                  <div
                                    className="btnSecondary ripple"
                                    style={{ backgroundColor: "white" }}
                                  >
                                    <span className="textGradianlarge">
                                      {i18next.t("segmentation")}
                                    </span>
                                  </div>
                                </span>
                              </Link>
                            )}
                            {!authorizationSegmentation && (
                              <div className="btnPrimaryDisabled">
                                <span>{i18next.t("segmentation")}</span>
                              </div>
                            )}
                          </span>
                        </div>
                      </div>
                    </li>
                    <li className="cart-box-incidents animated slideInLeft">
                      <div className="cart-incident">
                        <div className="box-header-custom overFlow">
                          <div className="box-center-display">
                            <div className="left part-left">
                              <span>{i18next.t("description")}</span>
                            </div>
                            <div className="part-right left ">
                              {Utils.simpleAuthorizationIsAllowed(User, [
                                Enums.AuthorizationRightsEnums.CAMERASTATIC,
                              ]) && (
                                <Link
                                  to={
                                    Paths.PathsNamesEnums.STATISTIC +
                                    `/${getCameraDetails.id}`
                                  }
                                  className="cursor"
                                >
                                  <svg
                                    width="40"
                                    height="40"
                                    viewBox="0 0 30 30"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      width="29"
                                      height="29"
                                      rx="4"
                                      fill="#EAF4FF"
                                    />
                                    <rect
                                      x="5.5"
                                      y="6.5"
                                      width="6"
                                      height="15"
                                      rx="0.5"
                                      fill="#1E87F0"
                                      fillOpacity="0.2"
                                      stroke="#028DFF"
                                    />
                                    <rect
                                      x="11.5"
                                      y="8.5"
                                      width="6"
                                      height="13"
                                      rx="0.5"
                                      fill="#1E87F0"
                                      fillOpacity="0.2"
                                      stroke="#028DFF"
                                    />
                                    <rect
                                      x="17.5"
                                      y="12.5"
                                      width="6"
                                      height="9"
                                      rx="0.5"
                                      fill="#1E87F0"
                                      fillOpacity="0.2"
                                      stroke="#028DFF"
                                    />
                                  </svg>
                                </Link>
                              )}
                              {!Utils.simpleAuthorizationIsAllowed(User, [
                                Enums.AuthorizationRightsEnums.CAMERASTATIC,
                              ]) && (
                                <Link
                                  to="#"
                                  onClick={noAction}
                                  style={{ cursor: "not-allowed" }}
                                >
                                  <svg
                                    width="40"
                                    height="40"
                                    viewBox="0 0 30 30"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      width="29"
                                      height="29"
                                      rx="4"
                                      fill="#EAF4FF"
                                    />
                                    <rect
                                      x="5.5"
                                      y="6.5"
                                      width="6"
                                      height="15"
                                      rx="0.5"
                                      fill="#1E87F0"
                                      fillOpacity="0.2"
                                      stroke="whitesmoke"
                                    />
                                    <rect
                                      x="11.5"
                                      y="8.5"
                                      width="6"
                                      height="13"
                                      rx="0.5"
                                      fill="#1E87F0"
                                      fillOpacity="0.2"
                                      stroke="whitesmoke"
                                    />
                                    <rect
                                      x="17.5"
                                      y="12.5"
                                      width="6"
                                      height="9"
                                      rx="0.5"
                                      fill="#1E87F0"
                                      fillOpacity="0.2"
                                      stroke="whitesmoke"
                                    />
                                  </svg>
                                </Link>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="descriptionSettings">
                          <div className="part-right left" />
                          <div className="part-right left settingsHeader">
                            <span className="borderGradian">
                              <span
                                className="btnSecondary "
                                style={{ backgroundColor: "white" }}
                                onClick={props.onOpenCameraInformation}
                              >
                                <span className="textGradianlarge">
                                  {i18next.t("details")}
                                </span>
                              </span>
                            </span>
                          </div>
                          <div className="part-right left">
                            <span>{i18next.t("nom technique")} :</span>
                          </div>
                          <div className="part-right left">
                            <span className="settingsLabel">
                              {props.nameCamera}
                            </span>
                          </div>
                          <div className="part-right left">
                            <span>{i18next.t("tube")} :</span>
                          </div>
                          <div className="part-right left">
                            <span className="settingsLabel">
                              {props.tubeCamera}
                            </span>
                          </div>
                          <div className="part-right left">
                            <span>{i18next.t("type")} :</span>
                          </div>
                          <div className="part-right left">
                            <span className="settingsLabel">
                              {props.typeCamera}
                            </span>
                          </div>
                          <div className="part-right left">
                            <span>{i18next.t("etat")} :</span>
                          </div>
                          <div className="part-right left">
                            <span className="settingsLabel">
                              {props.stateCamera}
                            </span>
                          </div>
                        </div>
                        <div className="box-header-custom overFlow">
                          <div className="box-center-display">
                            <div className="left part-left">
                              <span> {i18next.t("parametrages")}</span>
                            </div>
                          </div>
                        </div>
                        <div className="descriptionSettings" />

                        <div className="camera">
                          <div
                            className={cx("getTypesClass", {
                              activeInput: !authorization,
                            })}
                            style={{ width: "100%" }}
                          >
                            <span
                              className="settingsLabel"
                              style={{ fontWeight: 500 }}
                            >
                              {" "}
                              {i18next.t("inhibition")}
                            </span>
                            <span
                              key={shortid.generate()}
                              style={{ float: "right", paddingRight: "20px" }}
                            >
                              <CheckBoxGrid
                                id="setting-impact-camera-inhibition"
                                name="INHIBITION"
                                checked={props.inhibateBoolean}
                                onChecked={props.onInhibateAllIncident}
                                disabled={!authorization}
                              />
                            </span>
                          </div>

                          <div className="autoSegmentation">
                            <Scrollbars height="100%" width="100%">
                              {filterIncidentTypes &&
                                filterIncidentTypes.map(
                                  (item: any, index: number) => {
                                    return (
                                      <div
                                        key={index}
                                        className={cx("getTypesClass", {
                                          activeInput: !authorization,
                                        })}
                                        style={{ width: "100%" }}
                                      >
                                        <span>
                                          {i18next.t(`${item.label}`)}
                                        </span>
                                        <span
                                          style={{
                                            float: "right",
                                            paddingRight: "20px",
                                          }}
                                        >
                                          <CheckBoxGrid
                                            disabled={!authorization}
                                            name={i18next.t(`${item.label}`)}
                                            checked={checkTypesIncidents[index]}
                                            id={item.id}
                                            onChecked={onChange(index)}
                                          />
                                        </span>
                                      </div>
                                    );
                                  }
                                )}
                            </Scrollbars>
                          </div>
                        </div>
                        <div className="descriptionSettings-btn">
                          {authorization && (
                            <button
                              className="btnPrimary ripple"
                              onClick={onSubmit}
                            >
                              {i18next.t("enregistrer")}
                            </button>
                          )}
                          {!authorization && (
                            <button className="btnPrimaryDisabled">
                              {i18next.t("enregistrer")}
                            </button>
                          )}
                        </div>
                      </div>
                    </li>
                  </div>
                </section>
              </section>
            </section>
          </div>
        </section>
      )}
    </LayoutGrid>
  );
};

/** Valeurs par défaut des props */
Component.defaultProps = {};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */

/** @export HOC pure */
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/camera/settings/component.tsx